import ConfigPage from './ConfigPage';

export default ConfigPage;